import { GlobalContext } from "../../context/globalContext";
import { BusinessContext } from "../../context/businessContext";
import { Box, Link } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useContext, useEffect, useRef, useState } from "react";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import TkFakeTableLine from "../../components/atoms/TkFakeTableLine";
import TkTable from "../../components/atoms/TkTable";
import { httpAPI_PRE010 } from "./api/request";
import { staffInfoHeadTitleList } from "./parts";
import { authorityUserType } from "../../assets/data/TkAuthorityProperty";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { changeAmountFormat } from "../../utils/useTools";
import { TkGetCode } from "../../utils/TkGetCode";
import { TransferReason, TransitionalCode } from "../../assets/data/Constants";
import { TkRouteContext } from "../../context/tkRouteContext";
import "./_style.scss";

/**
 * SCRC080104 掛金納付対象職員届の提出確認詳細
 * @return SCRC080104 掛金納付対象職員届の提出確認詳細
 * @todo 持ち回り情報（掛金業務）の整理
 */
const SCRC080104 = () => {
  const navigate = useNavigate();
  const [bodyList, setBodyList] = useState<any>([]);
  const { state, setState } = useContext(GlobalContext);
  const { state: businessState } = useContext(BusinessContext);
  const isKikoUser =
    state?.authInfo?.userType === authorityUserType.userTypeNumber.KIKO;
  const { state: routerState } = useContext(TkRouteContext);

  const previousScreenIdRef = useRef<any>(null);

  useEffect(() => {
    if (routerState.routerList && routerState.routerList.length > 1) {
      const screenId =
        routerState.routerList[routerState.routerList.length - 2].href;
      previousScreenIdRef.current = screenId
        ? screenId.replace(/\//g, "")
        : null;
    } else {
      previousScreenIdRef.current = null;
    }
  }, [routerState]);

  // 氏名リンク押下時のイベント
  const onLinkClick = (staffNo: any) => {
    navigate("/SCRC080105", {
      state: {
        staffNo: staffNo,
      },
    });
  };

  //プルダウンの表示
  const newLable = `${businessState?.job_11?.facilityNo}:${businessState?.job_11?.facilityName}`;

  const handleCallApiInit = async () => {
    // 掛金納付対象職員届の提出確認参照API実行
    try {
      const res = await httpAPI_PRE010({
        contractorNo: isKikoUser
          ? businessState.common?.contractorNo
          : state.authInfo?.contractorNo,
        facilityNo: businessState?.job_11?.facilityNo + "",
        screenId: previousScreenIdRef.current ?? null,
      });

      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });

        let bodyList = res.staffInfoList?.map((item) => {
          return [
            {
              keyword: item.staffNameKanji,
              children: (
                <>
                  {item?.applicationPendingFlg === "0" ? (
                    <Link
                      onClick={() => onLinkClick(item.staffNo)}
                      data-testid="staffLink"
                    >
                      {`${
                        TransitionalCode[
                          item.transitionalCode as keyof typeof TransitionalCode
                        ] ?? ""
                      }${item.staffNo ?? ""}:${item.staffNameKanji ?? ""}`}
                    </Link>
                  ) : (
                    <>
                      {`${
                        TransitionalCode[
                          item.transitionalCode as keyof typeof TransitionalCode
                        ] ?? ""
                      }${item.staffNo ?? ""}:${item.staffNameKanji ?? ""}`}
                    </>
                  )}
                  <br />
                  {item.birthday}
                  <br />
                  {item.sex}
                </>
              ),
            },
            {
              children: (
                <>
                  {item.firstJoinDate}
                  <br />
                  {item.joinCapacity}
                  <br />
                  {item.jobCd}
                </>
              ),
            },
            {
              children: (
                <>
                  {item.enrollPeriod}
                  <br />
                  {item.validPeriod}
                </>
              ),
            },
            {
              align: "right",
              children: (
                <>
                  {changeAmountFormat(item.salaryTableAmt ?? 0)}
                  <br />
                  {changeAmountFormat(item.salaryAdjustmentAmt ?? 0)}
                </>
              ),
            },
            ...(isKikoUser
              ? [
                  {
                    children: (
                      <>
                        {TkGetCode(TransferReason, item.transferReason)}
                        <br />
                        {item.aFacilityNo} : {item.aFacilityName}
                      </>
                    ),
                  },
                ]
              : []),
            {
              children: [
                { name: "1月", value: item.jan },
                { name: "2月", value: item.feb },
                { name: "3月", value: item.mar },
                { name: "4月", value: item.apr },
                { name: "5月", value: item.may },
                { name: "6月", value: item.jun },
                { name: "7月", value: item.jul },
                { name: "8月", value: item.aug },
                { name: "9月", value: item.sep },
                { name: "10月", value: item.oct },
                { name: "11月", value: item.nov },
                { name: "12月", value: item.dec },
              ]
                .filter((month) => month.value === "1")
                .map((month) => month.name)
                .join("、"),
            },
            {
              children: item?.childcareLeaveInfoList?.length ? (
                <>
                  {item?.childcareLeaveInfoList.map((item, index) => {
                    return (
                      <Box key={index}>
                        {`出生日：${item?.birthday}`}
                        <br />
                        {`期間：${item?.getStartDate}-${item?.getEndDate}`}
                      </Box>
                    );
                  })}
                </>
              ) : (
                <></>
              ),
            },
            {
              align: "center",
              children: item.otherMaFlg === "1" && "〇",
            },
          ];
        });
        setBodyList(bodyList);
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
      }
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleCallApiInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box className={"SCRC080104"} data-testid="SCRC080104PageForTest">
      {isKikoUser && (
        <TkContractorAndNumberLine
          name="契約者（法人）名"
          no={`${businessState.common?.contractorNo || ""}:${
            businessState.common?.contractorName || ""
          }`}
        />
      )}
      <TkFakeTableLine
        title="施設名"
        type="selectForm"
        label={newLable}
        disabled={true}
        selectPropsList={[
          {
            label: newLable,
            value: "0",
          },
        ]}
      />

      <TkTable
        data-testid="tkTableForTest"
        headList={staffInfoHeadTitleList.filter((item) =>
          isKikoUser ? item : item.headTitle !== "異動内容"
        )}
        bodyList={bodyList}
        pagin
        showUnit
      />

      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLC080104_01}</TkInfoManual>
      <Box className="backButton">
        <TkBackButton />
      </Box>
    </Box>
  );
};

export default SCRC080104;
